import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { applyThemeMode, readDeviceTheme } from "../lib/theme";
import type { ThemeMode } from "../lib/theme";

interface ThemeState {
  mode: ThemeMode;
}

// Стартираме с темата на компютъра (lib/theme.ts) — още преди първия рендер, и
// на входа; без записана — „Оранжево“ (UserConfigurationSync я попълва
// еднократно от досегашната лична тема в базата).
const initialState: ThemeState = { mode: readDeviceTheme() ?? "light" };

applyThemeMode(initialState.mode);

// Заварени ключове от старите версии (темата до 0.0.234, свитите групи и
// изгледът на каталога в „Маркиране" до 14.09.2026 живееха в localStorage) —
// чистят се еднократно; могат да отпаднат след няколко релийза.
try {
  localStorage.removeItem("app_theme");
  localStorage.removeItem("ordering_category_rows_collapsed");
  localStorage.removeItem("ordering_catalog_view");
} catch {
  /* storage недостъпен */
}

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    // Само прилага в store-а и върху <html>. Записът на компютъра е отговорност
    // на извикващия (ThemeModal / UserConfigurationSync → saveDeviceTheme).
    setThemeMode(state, action: PayloadAction<ThemeMode>) {
      state.mode = action.payload;
      applyThemeMode(action.payload);
    },
  },
});

export const { setThemeMode } = themeSlice.actions;
export default themeSlice.reducer;
